import { Component } from "react";
import { connect } from "react-redux";

import { Get, Post } from "utils/axios";
import { requestError, requestSuccess } from "utils/requestHandler";
import { addLoadingContent, removeLoadingContent } from "reducers/LoadingOverlay";
import { convertObjectToBase64 } from "utils/objToBase64";
const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      rows: [],
      meta: {},
      query: { filter: {}, sorter: { createdAt: 'desc' } },
      selected: {},
      action: null,
      uploadedFileInfo: {},
      security_pin: null,
      showPinVerification: false,
      uploadAction: '',
    };
    
    load = (param) => {
      if (param) {
        this.props.addLoadingContent();
      } else {
        this.props.removeLoadingContent();
      }
    };
    
    onChangeHOC = (key, val) => this.setState({ [key]: val });
    
    verifySecurityPin = data => Post(
      `/verify_security_pin`,
      data,        // dynamically use state.pin
      this.verifySecurityPinSuccess,
      requestError,
      this.load
    );
    verifySecurityPinSuccess = (resp) => {
      this.setState({ action: null, showPinVerification: false});
      requestSuccess("Security Pin Verification Successful!");
      this.statementUploadAction(this.state.uploadAction)
    };
    
    
    
    getList = () => Get(
      `/wallet_statement_uploads?query=${convertObjectToBase64(this.state.query)}`,
      (resp) => this.setState({
        rows: resp.rows,
        meta: resp.meta,
      }),
      requestError,
      this.load
    )
    
    bulkUploadWalletAction = (payload) => Post(
      "/bulk_upload_wallet_action", 
      payload, 
      this.bulkUploadWalletActionSuccess,
      requestError,
      this.load
    );
    
    bulkUploadWalletActionSuccess = (resp) => {
      this.setState({ action: null, uploadedFileInfo: {}, query: { ...this.state.query, page: 1 } });
      requestSuccess("Bulk upload action successful!");
    };
    
    viewWalletStatementUploadDetail = (id) => Get(
      `/wallet_statement_uploads/${id}`,
      (resp) => this.setState({
        selected: resp,
        action: 'view'
      }),
      requestError,
      this.load
    )
    
    statementUploadAction = (action, id) => {
      const selected_id = id || this.state.selected.id
      
      switch (action) {
        case 'approve':
        case 'reject':
        Post(
          `/wallet_statement_uploads/${selected_id}/approval`,
          {
            action: action,
          },
          (resp) => {
            requestSuccess('Action successful!');
            this.setState({
              selected: {},
              action: null,
              showPinVerification: false
            });
            
            if(this.meta === 1) {
              this.getList();
            } else {
              this.setState({ query: { ...this.state.query, page: 1 } });
            }
          },
          requestError,
          this.load
        )
        break;
      }
    }
    
    render = () => {
      return (
        <WrappedComponent
        {...this.props}
        {...this.state}
        onChangeHOC={this.onChangeHOC}
        getList={this.getList}
        verifySecurityPin={this.verifySecurityPin}
        viewWalletStatementUploadDetail={this.viewWalletStatementUploadDetail}
        statementUploadAction={this.statementUploadAction}
        bulkUploadWalletAction={this.bulkUploadWalletAction}
        />
      );
    };
  }
  
  const mapStateToProps = (state) => ({
    data: state,
    selectedLanguage: state.ProfileReducer.profile.preferred_language,
    siteInfo: state.ClientReducer.siteInfo,
    profile: state.ProfileReducer.profile,
    colors: state.ClientReducer.clientInfo.styles?.colors
  });
  return connect(mapStateToProps, { addLoadingContent, removeLoadingContent })(WithHOC);
};

export default HOC;
